import { RiSaveLine } from "@itandi/itandi-bb-ui";
import { Button } from "@itandi/itandi-bb-ui/Button";
import { useRouter } from "next/router";
import React from "react";
import { useFormContext } from "react-hook-form";
import { toast } from "react-toastify";
import useLoader from "~/hooks/useLoader";
import type { Deal } from "~/models/Deal";
import type { RelatedDealParam } from "~/models/DealForm";
import { normalizeFields } from "~/models/DealForm";
import { PATH } from "~/pages/deals/[id]";
import { isSuccess } from "~/utils/api/api_handler";
import { create } from "~/utils/api/deals/RelatedDeal";
import { onInvalidScroll } from "~/utils/FormUtil";
import Styles from "../../../../../common/deals/new/DealEditorFooter.module.scss";

type Props = {
	deal: Deal;
};

export const DealEditorFooter: React.FC<Props> = ({ deal }) => {
	const router = useRouter();
	const { handleSubmit } = useFormContext<RelatedDealParam>();
	const { Loader, showLoader, hideLoader } = useLoader();
	const onClickSubmit = React.useCallback(() => {
		handleSubmit(
			async (values) => {
				showLoader();
				const response = await create(normalizeFields(values), deal.id);
				const responseId = response.data?.id;
				if (isSuccess(response) && responseId !== undefined) {
					await router.push(PATH(responseId));
					toast.success("作成しました。");
				} else {
					toast.error("エラーが発生しました。");
				}
				hideLoader();
			},
			(errors) => {
				onInvalidScroll(errors);
			}
		)();
	}, [handleSubmit, showLoader, hideLoader, router, deal]);
	return (
		<div className={Styles.DealEditorFooter}>
			<Loader />
			<Button
				className={Styles.SaveButton}
				onClick={onClickSubmit}
				startIcon={<RiSaveLine className={Styles.Icon} />}
				variant="primary"
			>
				保存
			</Button>
		</div>
	);
};
